import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, X } from 'lucide-react';

const AgeVerification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has already verified age
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setIsVisible(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsVisible(false);
    // Dispatch custom event to notify cookie consent
    window.dispatchEvent(new CustomEvent('ageVerified'));
  };

  const handleDecline = () => {
    // Redirect to responsible gaming page or show message
    navigate('/responsible-gaming');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[100] max-w-sm transform transition-all duration-300">
      <div className="glass-strong rounded-2xl p-5 shadow-2xl border border-white/30">
        <div className="flex items-start space-x-3 mb-4">
          <AlertTriangle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
          <div className="flex-1">
            <h3 className="font-bold text-gray-800 mb-2">Age Verification</h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              You must be 18 or older to access this website. By continuing, you confirm that you are of legal gambling age.
            </p>
          </div>
          <button
            onClick={() => setIsVisible(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex flex-col gap-2 mt-4">
          <button
            onClick={handleConfirm}
            className="w-full px-4 py-2 bg-gradient-to-r from-pink-600 to-green-600 text-white text-sm font-semibold rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300"
          >
            I am 18 or older
          </button>
          <button
            onClick={handleDecline}
            className="w-full px-4 py-2 bg-gray-200 text-gray-700 text-sm font-semibold rounded-lg hover:bg-gray-300 transition-colors"
          >
            I am under 18
          </button>
        </div>

        <div className="mt-3 text-center">
          <p className="text-xs text-gray-500">
            Please gamble responsibly. Visit{' '}
            <a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="text-green-600 hover:underline">
              BeGambleAware.org
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AgeVerification;

